import React, {useEffect, useState} from 'react';
import PainSvg from './svg';

const PAIN_SCALE = (props) => {
    const { height, questionIndex, onAnswer } = props;
    const [ selected, setSelected ] = useState(null);
    const [ description, setDescription ] = useState('');

    const onClick = (value, desc) => {
        setSelected(value);
        setDescription(desc);
        if (onAnswer) {
            onAnswer(value, questionIndex);
        }
    }

    const svgProps = { onClick, selected, height };

    return (
        <div>
            <PainSvg {...svgProps} />
            {selected ? (
                <div className="text-center">
                    <h2>{selected}</h2>
                    <h4>SELECTED</h4>
                    <div>{description}</div>
                </div>
            ): (
                <div className="text-center">
                    <h4>Select a number to start</h4>
                    <div className="mt-3">Can't see the description?</div>
                    <div>On select, you will see the description here</div>
                </div>
            )}
        </div>
    )
}

export default PAIN_SCALE;